const BASE_URL = process.env.SLATE_ACCESSORIES_API_URL;

export const SLATE_ACCESSORIES_ENDPOINTS = {
  ACCESSORIES: `${BASE_URL}/api/v1/accessories`
};
